import { createRouter, createWebHashHistory } from "vue-router";
import cookie from "js-cookie";
import HomeView from "../views/home/index.vue";
import Login from "../views/login.vue";
import HistotyRrecord from "@/views/HistotyRrecord/HistotyRrecord.vue";
import RootSetting from "@/views/RootSetting/RootSetting.vue";
import Chart from "@/views/Chart/Chart.vue";
const routes = [
	{
		path: "/",
		redirect: "/Login",
	},
	{
		path: "/login",
		name: "login",
		component: Login,
	},
	{
		path: "/",
		name: "home",
		component: HomeView,
		children: [
			{
				path: "/HistotyRrecord",
				name: "HistotyRrecord",
				component: HistotyRrecord,
			},
			{
				path: "/RootSetting",
				name: "RootSetting",
				component: RootSetting,
			},
			{
				path: "/Chart",
				name: "Chart",
				component: Chart,
				props: (route) => ({ customData: route.query.customData }),
				meta: {
					keepAlive: true,
				},
			},
		],
	},
];

const router = createRouter({
	history: createWebHashHistory(),
	routes,
});

export default router;
